import * as i0 from '@angular/core';
import { Injectable, Component, NgModule } from '@angular/core';
import * as i2 from '@angular/fire/compat/auth';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import * as i1$1 from '@angular/fire/compat/firestore';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { __awaiter } from 'tslib';
import { BehaviorSubject } from 'rxjs';
import firebase from 'firebase/compat/app';
import * as i2$1 from 'octali-lib-utils';
import * as i1 from '@angular/router';
import { map } from 'rxjs/operators';
import * as moment from 'moment';
import * as i1$2 from '@angular/fire/compat/storage';
import { Filesystem, Directory, Encoding } from '@capacitor/filesystem';
import * as i1$3 from '@ionic/angular';
import * as i2$2 from 'ngx-papaparse';

class OctaliLibFirebaseUtilsService {
    constructor() { }
}
OctaliLibFirebaseUtilsService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: OctaliLibFirebaseUtilsService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
OctaliLibFirebaseUtilsService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: OctaliLibFirebaseUtilsService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: OctaliLibFirebaseUtilsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return []; } });

class OctaliLibFirebaseUtilsComponent {
    constructor() { }
    ngOnInit() {
    }
}
OctaliLibFirebaseUtilsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: OctaliLibFirebaseUtilsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
OctaliLibFirebaseUtilsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.1.3", type: OctaliLibFirebaseUtilsComponent, selector: "ctl-octali-lib-firebase-utils", ngImport: i0, template: `
    <p>
      octali-lib-firebase-utils works!
    </p>
  `, isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: OctaliLibFirebaseUtilsComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'ctl-octali-lib-firebase-utils',
                    template: `
    <p>
      octali-lib-firebase-utils works!
    </p>
  `,
                    styles: []
                }]
        }], ctorParameters: function () { return []; } });

class OctaliLibFirebaseUtilsModule {
}
OctaliLibFirebaseUtilsModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: OctaliLibFirebaseUtilsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
OctaliLibFirebaseUtilsModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: OctaliLibFirebaseUtilsModule, declarations: [OctaliLibFirebaseUtilsComponent], exports: [OctaliLibFirebaseUtilsComponent] });
OctaliLibFirebaseUtilsModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: OctaliLibFirebaseUtilsModule, providers: [
        AngularFireAuth,
        AngularFirestore,
    ], imports: [[]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: OctaliLibFirebaseUtilsModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        OctaliLibFirebaseUtilsComponent
                    ],
                    imports: [],
                    providers: [
                        AngularFireAuth,
                        AngularFirestore,
                    ],
                    exports: [
                        OctaliLibFirebaseUtilsComponent,
                    ]
                }]
        }] });

class AuthService {
    constructor(afAuth, logger, displayer) {
        this.afAuth = afAuth;
        this.logger = logger;
        this.displayer = displayer;
        this.user = null;
        this.user$ = new BehaviorSubject(null);
        this.afAuth.authState.subscribe(user => {
            this.logger.message(AuthService.name + " - constructor", "change user");
            this.logger.object(AuthService.name + " - constructor", user);
            this.user$.next(user);
        });
    }
    /**
       * fonction qui créer un compte à partir d'un mail et d'un mot de passe et se connecte
       * @param email email de connexion
       * @param password mot de passe
       * @returns en promesse, l'utilisateur connecté
       */
    signup(email, password) {
        return this.afAuth.createUserWithEmailAndPassword(email, password).then(credentials => {
            return credentials.user;
        }).catch(err => {
            this.logger.object(AuthService.name + " - signup", err, "err");
            return null;
        });
    }
    /**
     * fonction qui permet la connection à partir d'un mail et d'un mot de passe
     * @param email email de connexion
     * @param password mot de passe
     * @returns résultat de la connexion
     */
    login(email, password) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.afAuth.signInWithEmailAndPassword(email, password).then(credentials => {
                this.logger.message(AuthService.name + " - login", "login sucess");
                return credentials.user;
            }).catch((err) => __awaiter(this, void 0, void 0, function* () {
                this.logger.object(AuthService.name + " - login", err, "err");
                switch (err.code) {
                    case "auth/user-not-found":
                        yield this.displayer.presentAlert("Erreur de connexion", "", "Aucun utilisateur ne correspond à votre saisie dans notre système");
                        break;
                    case "auth/invalid-password":
                        yield this.displayer.presentAlert("Erreur de connexion", "", "Mot de passe erroné");
                        break;
                    case "auth/invalid-email":
                        yield this.displayer.presentAlert("Erreur de connexion", "", "Identifiant erroné");
                        break;
                }
                return null;
            }));
        });
    }
    /**
     * fonction qui fait une connection en anonyme
     * @returns en promesse, les crédit de connection
     */
    anonymousLogin() {
        return this.afAuth.signInAnonymously().then(credentials => {
            this.logger.message(AuthService.name + " - anonymousLogin", "login sucess");
            return credentials.user;
        }).catch(err => {
            this.logger.object(AuthService.name + " - anonymousLogin", err, "err");
            return null;
        });
    }
    /**
     * fonction qui lie un compte anonyme à un compte identifié
     * @returns en promesse, les crédits de connection
     */
    linkAccount(email, password) {
        const credential = firebase.auth.EmailAuthProvider.credential(email, password);
        if (this.user$.getValue() != null) {
            return this.user$.getValue().linkWithCredential(credential).then(credentials => {
                this.logger.message(AuthService.name + " - linkAccount", "linking sucess");
                return credentials.user;
            }).catch(err => {
                this.logger.object(AuthService.name + " - linkAccount", err, "err");
                return null;
            });
        }
        else {
            return this.afAuth.currentUser.then((user) => __awaiter(this, void 0, void 0, function* () {
                if (user != null)
                    return user.linkWithCredential(credential).then(credentials => {
                        this.logger.message(AuthService.name + " - linkAccount", "linking sucess");
                        return credentials.user;
                    }).catch(err => {
                        this.logger.object(AuthService.name + " - linkAccount", err, "err");
                        return null;
                    });
                else
                    return yield this.signup(email, password);
            })).catch(err => {
                this.logger.object(AuthService.name + " - linkAccount", err, "err");
                return null;
            });
        }
    }
    /**
     * fonction qui permet la déconnection
     * @returns résultat de la connexion
     */
    logout() {
        return this.afAuth.signOut().then(() => {
            this.logger.message(AuthService.name + " - logout", "logout success");
            this.user$.next(null);
            return true;
        }).catch(err => {
            this.logger.object(AuthService.name + " - logout", err, "err");
            return false;
        });
    }
    /**
     * fonction qui permet la réinitialisation d'un mot de passe
     * @returns void
     */
    passwordReset(email) {
        return this.afAuth.sendPasswordResetEmail(email);
    }
    /**
     * fonction qui retourne un observateur d'utilisateur firebase
     * @returns un observateur d'utilisateur firebase
     */
    getUser() {
        return this.user$;
    }
}
AuthService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: AuthService, deps: [{ token: i2.AngularFireAuth }, { token: i2$1.LoggerService }, { token: i2$1.DisplayerService }], target: i0.ɵɵFactoryTarget.Injectable });
AuthService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: AuthService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: AuthService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i2.AngularFireAuth }, { type: i2$1.LoggerService }, { type: i2$1.DisplayerService }]; } });

class AuthGuard {
    constructor(router, afAuth, displayer, authService, logger) {
        this.router = router;
        this.afAuth = afAuth;
        this.displayer = displayer;
        this.authService = authService;
        this.logger = logger;
    }
    canActivate(next, state) {
        return new Promise((resolve, reject) => {
            this.logger.message(AuthGuard.name, "begin");
            this.afAuth.onAuthStateChanged((user) => __awaiter(this, void 0, void 0, function* () {
                if (user) {
                    this.logger.message(AuthGuard.name, "connect");
                    resolve(true);
                }
                else {
                    //this.router.navigate(["/landing"]);
                    this.logger.message(AuthGuard.name, "not connect");
                    yield this.displayer.presentLoader("Veuillez patientez<br/>Initialisation en cours");
                    this.authService.anonymousLogin().then((credentials) => __awaiter(this, void 0, void 0, function* () {
                        yield this.displayer.dismissLoader();
                        this.logger.message(AuthGuard.name, "anonymous");
                        resolve(true);
                        this.logger.message(AuthGuard.name, "end");
                    })).catch(err => {
                        reject(err);
                        this.logger.message(AuthGuard.name, "error");
                        this.logger.message(AuthGuard.name, "end");
                    });
                }
            }));
        });
    }
}
AuthGuard.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: AuthGuard, deps: [{ token: i1.Router }, { token: i2.AngularFireAuth }, { token: i2$1.DisplayerService }, { token: AuthService }, { token: i2$1.LoggerService }], target: i0.ɵɵFactoryTarget.Injectable });
AuthGuard.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: AuthGuard, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: AuthGuard, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.Router }, { type: i2.AngularFireAuth }, { type: i2$1.DisplayerService }, { type: AuthService }, { type: i2$1.LoggerService }]; } });

class ProfileDaoService {
    constructor(afStore, logger) {
        this.afStore = afStore;
        this.logger = logger;
    }
    /**
     * Fonction qui créer un nouveau profile
     * @param user : un utilisateur firebase
     * @returns : en promesse - un profile
     */
    createUser(user) {
        return __awaiter(this, void 0, void 0, function* () {
            let map = this.mapUserToBdd(user);
            this.logger.object(ProfileDaoService.name + " - createUser", map);
            return this.afStore.firestore.collection("userProfiles").doc(user.uid).set(map).then(() => {
                this.logger.message(ProfileDaoService.name + " - createUser", "User created");
                return this.mapUserProfile(user);
            }).catch(err => {
                this.logger.object(ProfileDaoService.name + " - createUser", err, "err");
                return null;
            });
        });
    }
    /**
     * fonction qui met à jour un profile à partir d'un utilisateur firebase
     * @param user : un utilisateur firebase
     * @returns : en promesse, un profile utilisateur
     */
    updateUser(user) {
        return __awaiter(this, void 0, void 0, function* () {
            let map = this.mapUserToBdd(user);
            this.logger.message(ProfileDaoService.name, "- updateUser");
            this.logger.object(ProfileDaoService.name, user);
            this.logger.object(ProfileDaoService.name, map);
            return this.afStore.firestore.collection("userProfiles").doc(user.uid).update(map).then(() => {
                this.logger.message(ProfileDaoService.name + " - updateUser", "User updated");
                return true;
            }).catch(err => {
                this.logger.object(ProfileDaoService.name + " - updateUser", err, "err");
                return false;
            });
        });
    }
    /**
     * fonction qui récupère et initialise un profile
     * @param user : utilisateur firebase
     * @returns void
     */
    initProfile(user) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.afStore.firestore.collection("userProfiles").doc(user.uid).get().then((p) => __awaiter(this, void 0, void 0, function* () {
                if (p.exists) {
                    return this.mapDocumentProfile(p.data());
                }
                else {
                    return yield this.createUser(user);
                }
            }));
        });
    }
    /**
     * fonction qui créé un profile
     * @param profile : l'profile à créer
     * @returns en promesse, l'profile créé
     */
    createProfile(profile) {
        return __awaiter(this, void 0, void 0, function* () {
            this.logger.object(ProfileDaoService.name + " - createProfile", profile);
            let id = this.afStore.createId();
            let createdAt = moment.now().toString();
            profile.createdAt = createdAt;
            profile.lastConnection = createdAt;
            profile.isAnonym = false;
            profile.uid = id;
            let map = this.mapProfileToBdd(profile);
            return this.afStore.firestore.collection("profile").doc(profile.uid).set(map).then(() => {
                this.logger.message(ProfileDaoService.name + " - createProfile", "Profile created");
                return true;
            }).catch(err => {
                this.logger.object(ProfileDaoService.name + " - createProfile", err, "err");
                return false;
            });
        });
    }
    /**
     * fonction qui met à jour un profile
     * @param profile : l'profile à mettre à jour
     * @returns en promesse, l'profile modifié
     */
    updateProfile(profile) {
        return __awaiter(this, void 0, void 0, function* () {
            this.logger.object(ProfileDaoService.name + " - updateProfile", profile);
            let map = this.mapProfileToBdd(profile);
            return this.afStore.firestore.collection("userProfiles").doc(profile.uid).update(map).then(() => {
                this.logger.message(ProfileDaoService.name + " - updateProfile", "Profile updated");
                return true;
            }).catch(err => {
                this.logger.object(ProfileDaoService.name + " - updateProfile", err, "err");
                return false;
            });
        });
    }
    /**
     * Fonction qui supprime un profile
     * @param profile profile à supprimer
     * @returns vrai ou faux suivant le résultat de l'opération
     */
    deleteProfile(profile) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.afStore.firestore.collection("userProfiles").doc(profile.uid).delete().then(() => {
                this.logger.message(ProfileDaoService.name + " - deleteProfile", "Profile deleted");
                return true;
            }).catch(err => {
                this.logger.object(ProfileDaoService.name + " - deleteProfile", err, "err");
                return false;
            });
        });
    }
    /**
    * fonction qui map un utilisateur firebase en profile
    * @param datas : un utilisateur firebase
    * @returns l'profile créer
    */
    mapUserProfile(datas) {
        let lastSignInTime = null;
        if (datas.metadata != undefined && datas.metadata.lastSignInTime != undefined)
            lastSignInTime = datas.metadata.lastSignInTime;
        let creationTime = null;
        if (datas.metadata != undefined && datas.metadata.creationTime != undefined)
            creationTime = datas.metadata.creationTime;
        let profile = {
            uid: datas.uid,
            mail: datas.email,
            isVerified: datas.emailVerified,
            isAnonym: datas.isAnonymous,
            lastConnection: lastSignInTime,
            createdAt: creationTime,
            firstname: null,
            lastname: null,
            phone: null,
            mobile: null,
            dateOfBirth: null,
            isAdmin: false,
            tokens: null,
            actif: true
        };
        return profile;
    }
    /**
    * fonction qui map un document firestore en profile
    * @param datas : document firestore
    * @returns l'profile créer
    */
    mapDocumentProfile(datas) {
        let tokens = new Map();
        if (datas['tokens'] != null) {
            for (const token of datas['tokens']) {
                tokens.set(token.device, token.token);
            }
        }
        let profile = {
            uid: datas['uid'],
            mail: datas['mail'],
            isVerified: datas['isVerified'],
            isAnonym: datas['isAnonym'],
            lastConnection: datas['lastConnection'],
            createdAt: datas['createdAt'],
            firstname: datas['firstname'],
            lastname: datas['lastname'],
            phone: datas['phone'],
            mobile: datas['mobile'],
            dateOfBirth: datas['dateOfBirth'],
            isAdmin: datas['isAdmin'],
            tokens: tokens,
            actif: datas['actif']
        };
        return profile;
    }
    mapProfileToBdd(profile) {
        var tokens = [];
        if (profile.tokens)
            for (let [device, token] of profile.tokens) {
                tokens.push({ device: device, token: token });
            }
        let p = profile;
        p.tokens = tokens;
        return p;
    }
    mapUserToBdd(user) {
        let p = {
            uid: user.uid,
            mail: user.email,
            isAnonym: user.isAnonymous,
            isVerified: user.emailVerified,
            createdAt: user.metadata.creationTime,
            lastConnection: user.metadata.lastSignInTime,
        };
        return p;
    }
    /**
     * Fonction qui met à jour la liste des tokens d'un profile
     * @param profile profile à mettre à jour
     * @returns en promesse, un boolean qui indique si la mise à jour est effective
     */
    updateTokens(profile) {
        return __awaiter(this, void 0, void 0, function* () {
            var tokens = [];
            if (profile.tokens)
                for (let [key, value] of profile.tokens)
                    tokens.push({ device: key, token: value });
            return this.afStore.firestore.collection("userProfiles").doc(profile.uid).update({
                tokens: tokens
            }).then(() => {
                this.logger.message(ProfileDaoService.name + " - updateTokens", "Tokens updated");
                this.logger.object(ProfileDaoService.name + " - updateTokens", tokens);
                return true;
            }).catch(err => {
                this.logger.object(ProfileDaoService.name + " - updateTokens", err, "err");
                return false;
            });
        });
    }
    /**
     * Fonction qui met à jour le nom de famille
     * @param profile profile à mettre à jour
     * @returns vrai ou faux suivant le résultat de l'opération
     */
    updateFirstname(profile) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.afStore.firestore.collection("userProfiles").doc(profile.uid).update({
                firstname: profile.firstname
            }).then(() => {
                this.logger.message(ProfileDaoService.name + " - updateFirstname", "firstname updated");
                return true;
            }).catch(err => {
                this.logger.object(ProfileDaoService.name + " - updateFirstname", err, "err");
                return false;
            });
        });
    }
    /**
     * Fonction qui met à jour le prénom
     * @param profile profile à mettre à jour
     * @returns vrai ou faux suivant le résultat de l'opération
     */
    updateLastname(profile) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.afStore.firestore.collection("userProfiles").doc(profile.uid).update({
                lastname: profile.lastname
            }).then(() => {
                this.logger.message(ProfileDaoService.name + " - updateLastname", "lastname updated");
                return true;
            }).catch(err => {
                this.logger.object(ProfileDaoService.name + " - updateLastname", err, "err");
                return false;
            });
        });
    }
    /**
     * Fonction qui met à jour le mail
     * @param profile profile à mettre à jour
     * @returns vrai ou faux suivant le résultat de l'opération
     */
    updateMail(profile) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.afStore.firestore.collection("userProfiles").doc(profile.uid).update({
                mail: profile.mail
            }).then(() => {
                this.logger.message(ProfileDaoService.name + " - updateMail", "mail updated");
                return true;
            }).catch(err => {
                this.logger.object(ProfileDaoService.name + " - updateMail", err, "err");
                return false;
            });
        });
    }
    /**
     * Fonction qui met à jour le téléphone fixe
     * @param profile profile à mettre à jour
     * @returns vrai ou faux suivant le résultat de l'opération
     */
    updatePhone(profile) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.afStore.firestore.collection("userProfiles").doc(profile.uid).update({
                phone: profile.phone
            }).then(() => {
                this.logger.message(ProfileDaoService.name + " - updatePhone", "phone updated");
                return true;
            }).catch(err => {
                this.logger.object(ProfileDaoService.name + " - updatePhone", err, "err");
                return false;
            });
        });
    }
    /**
     * Fonction qui met à jour le téléphone mobile
     * @param profile profile à mettre à jour
     * @returns vrai ou faux suivant le résultat de l'opération
     */
    updateMobile(profile) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.afStore.firestore.collection("userProfiles").doc(profile.uid).update({
                mobile: profile.mobile
            }).then(() => {
                this.logger.message(ProfileDaoService.name + " - updateMobile", "mobile updated");
                return true;
            }).catch(err => {
                this.logger.object(ProfileDaoService.name + " - updateMobile", err, "err");
                return false;
            });
        });
    }
    /**
     * Fonction qui met à jour le statut
     * @param profile profile à mettre à jour
     * @returns vrai ou faux suivant le résultat de l'opération
     */
    updateActif(profile) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.afStore.firestore.collection("userProfiles").doc(profile.uid).update({
                actif: profile.actif
            }).then(() => {
                this.logger.message(ProfileDaoService.name + " - updateActif", "actif updated");
                return true;
            }).catch(err => {
                this.logger.object(ProfileDaoService.name + " - updateActif", err, "err");
                return false;
            });
        });
    }
    /**
     * Fonction qui met à jour si l'utilisateur est admin ou non
     * @param profile profile à mettre à jour
     * @returns vrai ou faux suivant le résultat de l'opération
     */
    updateIsAdmin(profile) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.afStore.firestore.collection("userProfiles").doc(profile.uid).update({
                isAmin: profile.isAdmin
            }).then(() => {
                this.logger.message(ProfileDaoService.name + " - updateIsAdmin", "isAmin updated");
                return true;
            }).catch(err => {
                this.logger.object(ProfileDaoService.name + " - updateIsAdmin", err, "err");
                return false;
            });
        });
    }
    /**
     * Fonction qui met à jour si l'utilisateur est vérifié ou non
     * @param profile profile à mettre à jour
     * @returns vrai ou faux suivant le résultat de l'opération
     */
    updateIsVerified(profile) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.afStore.firestore.collection("userProfiles").doc(profile.uid).update({
                isVerified: profile.isVerified
            }).then(() => {
                this.logger.message(ProfileDaoService.name + " - updateIsVerified", "isVerified updated");
                return true;
            }).catch(err => {
                this.logger.object(ProfileDaoService.name + " - updateIsVerified", err, "err");
                return false;
            });
        });
    }
    /**
     * Fonction qui met à jour si l'utilisateur est anonyme ou non
     * @param profile profile à mettre à jour
     * @returns vrai ou faux suivant le résultat de l'opération
     */
    updateIsAnonym(profile) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.afStore.firestore.collection("userProfiles").doc(profile.uid).update({
                isAnonym: profile.isAnonym
            }).then(() => {
                this.logger.message(ProfileDaoService.name + " - updateIsAnonym", "isAnonym updated");
                return true;
            }).catch(err => {
                this.logger.object(ProfileDaoService.name + " - updateIsAnonym", err, "err");
                return false;
            });
        });
    }
    /**
     * Fonction qui met à jour la date de naissance d'un profile utilisateur
     * @param profile profile à mettre à jour
     * @returns en promesse, un boolean qui indique si la mise à jour est effective
     */
    updateDateOfBirth(profile) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.afStore.firestore.collection("userProfiles").doc(profile.uid).update({
                dateOfBirth: profile.dateOfBirth
            }).then(() => {
                this.logger.message(ProfileDaoService.name + " - updateDateOfBirth", "dateOfBirth updated");
                return true;
            }).catch(err => {
                this.logger.object(ProfileDaoService.name + " - updateDateOfBirth", err, "err");
                return false;
            });
        });
    }
    /**
     * Fonction qui met à jour la date de dernière connexion
     * @param profile profile à mettre à jour
     * @returns en promesse, un boolean qui indique si la mise à jour est effective
     */
    updateLastConnection(profile) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.afStore.firestore.collection("userProfiles").doc(profile.uid).update({
                lastConnection: profile.lastConnection
            }).then(() => {
                this.logger.message(ProfileDaoService.name + " - updateLastConnection", "lastConnection updated");
                return true;
            }).catch(err => {
                this.logger.object(ProfileDaoService.name + " - updateLastConnection", err, "err");
                return false;
            });
        });
    }
    /**
     * Fonction qui met à jour la date de création
     * @param profile profile à mettre à jour
     * @returns en promesse, un boolean qui indique si la mise à jour est effective
     */
    updateCreatedDate(profile) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.afStore.firestore.collection("userProfiles").doc(profile.uid).update({
                createdAt: profile.createdAt
            }).then(() => {
                this.logger.message(ProfileDaoService.name + " - updateCreatedDate", "createdAt updated");
                return true;
            }).catch(err => {
                this.logger.object(ProfileDaoService.name + " - updateCreatedDate", err, "err");
                return false;
            });
        });
    }
    /**
     * Fonction qui recherche un profil par son identifiant
     * @param uid
     * @returns
     */
    getProfileByUid(uid) {
        return this.afStore.firestore.collection("userProfiles").doc(uid).get().then(p => {
            if (p.exists) {
                return this.mapDocumentProfile(p.data());
            }
            else {
                return null;
            }
        });
    }
    getProfiles$() {
        return this.afStore.collection("userProfiles").valueChanges().
            pipe(map(profiles => profiles), map(profiles => {
            for (let profile of profiles) {
                let tokens = new Map();
                if (profile.tokens)
                    for (let token of profile.tokens)
                        tokens.set(token['device'], token['token']);
            }
            return profiles;
        }));
    }
    getProfilesWithLimitAsync(limit = 8, start = null, orderBy = "") {
        this.logger.message(ProfileDaoService.name, "getProfilesWithLimitAsync start");
        return new Promise(resolve => {
            if (start == null) {
                if (orderBy == "")
                    return this.afStore.collection("userProfiles").ref.where("isAnonym", "==", false).limit(limit).get()
                        .then((users) => {
                        this.logger.object(ProfileDaoService.name, users);
                        this.logger.object(ProfileDaoService.name, users.docs);
                        let results = [];
                        for (let user of users.docs)
                            results.push(this.mapDocumentProfile(user.data()));
                        this.logger.object(ProfileDaoService.name, results);
                        resolve({ profiles: results, last: users.docs[users.docs.length - 1] });
                    });
                else
                    return this.afStore.collection("userProfiles").ref.where("isAnonym", "==", false).orderBy(orderBy).limit(limit).get().then((users) => __awaiter(this, void 0, void 0, function* () {
                        let results = [];
                        for (let user of users.docs)
                            results.push(this.mapDocumentProfile(user.data()));
                        this.logger.object(ProfileDaoService.name, results);
                        resolve({ profiles: results, last: users.docs[users.docs.length - 1] });
                    }));
            }
            else {
                if (orderBy == "")
                    return this.afStore.collection("userProfiles").ref.where("isAnonym", "==", false).startAfter(start).limit(limit).get().then((users) => __awaiter(this, void 0, void 0, function* () {
                        let results = [];
                        for (let user of users.docs)
                            results.push(this.mapDocumentProfile(user.data()));
                        this.logger.object(ProfileDaoService.name, results);
                        resolve({ profiles: results, last: users.docs[users.docs.length - 1] });
                    }));
                else
                    return this.afStore.collection("userProfiles").ref.where("isAnonym", "==", false).orderBy(orderBy).startAfter(start).limit(limit).get().then((users) => __awaiter(this, void 0, void 0, function* () {
                        let results = [];
                        for (let user of users.docs)
                            results.push(this.mapDocumentProfile(user.data()));
                        this.logger.object(ProfileDaoService.name, results);
                        resolve({ profiles: results, last: users.docs[users.docs.length - 1] });
                    }));
            }
        });
    }
}
ProfileDaoService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: ProfileDaoService, deps: [{ token: i1$1.AngularFirestore }, { token: i2$1.LoggerService }], target: i0.ɵɵFactoryTarget.Injectable });
ProfileDaoService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: ProfileDaoService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: ProfileDaoService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1$1.AngularFirestore }, { type: i2$1.LoggerService }]; } });

class UserService {
    constructor(authService, profileDAO, logger) {
        this.authService = authService;
        this.profileDAO = profileDAO;
        this.logger = logger;
        this.profile$ = new BehaviorSubject(null);
        this.subscriptionAuth = this.authService.getUser().subscribe((user) => __awaiter(this, void 0, void 0, function* () {
            if (user) {
                this.logger.message(UserService.name + " - constructor", "User changed");
                this.logger.object(UserService.name + " - constructor", user);
                //Promise.all( [
                //await this.profileDAO.updateUser( user );
                this.profileDAO.initProfile(user)
                    //] ).then( results => {
                    .then(results => {
                    this.logger.object(UserService.name + " - constructor", results);
                    this.profile$.next(results);
                }).catch(err => {
                    this.logger.object(UserService.name + " - constructor", err, "err");
                    this.profile$.next(null);
                });
            }
            else {
                this.profile$.next(null);
            }
        }));
    }
    /**
     * fonction qui déconnecte l'utilisateur
     * @returns en promesse, un boolean qui indique si la déconnection est réussie
     */
    logout() {
        return this.authService.logout().then(() => {
            this.profile$.next(null);
            return true;
        }).catch(err => {
            this.logger.object(UserService.name + " - logout", err, "err");
            return false;
        });
    }
    /**
     * fonction qui connecte l'utilisateur
     * @param email email de l'utilisateur
     * @param password mot de passe
     * @returns en promesse, un boolean qui indique si la connexion est réussie
     */
    login(email, password) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.authService.login(email, password).then(user => {
                if (user) {
                    return true;
                }
                else
                    return false;
            });
        });
    }
    /**
       * fonction qui créer un compte à partir d'un mail et d'un mot de passe et se connecte
       * @param email email de connexion
       * @param password mot de passe
       * @returns en promesse, l'utilisateur connecté
       */
    signup(email, password) {
        return this.authService.signup(email, password).then(user => {
            if (user) {
                return true;
            }
            else
                return false;
        });
    }
    /**
     * fonction qui fait une connection en anonyme
     * @returns en promesse, les crédit de connection
     */
    anonymousLogin() {
        return this.authService.anonymousLogin().then(user => {
            if (user) {
                return true;
            }
            else
                return false;
        });
    }
    /**
     * fonction qui lie un compte anonyme à un compte identifié
     * @returns en promesse, les crédits de connection
     */
    linkAccount(email, password) {
        return this.authService.linkAccount(email, password).then(user => {
            if (user) {
                return true;
            }
            else
                return false;
        });
    }
    /**
    * fonction qui permet la réinitialisation d'un mot de passe
    * @returns void
    */
    passwordReset(email) {
        this.authService.passwordReset(email);
    }
    /**
     * fonction qui return un observeur du profile
     * @returns BehaviorSubject<Profile> : un BehaviorSubject d'un profile
     */
    getUser() {
        return this.profile$;
    }
    createUser(profile) {
        this.logger.object(UserService.name + " - createUser", profile);
        return this.profileDAO.createProfile(profile).then(() => {
            this.profile$.next(profile);
            return true;
        }).catch(err => {
            this.logger.object(UserService.name + " - createAgent", err, "err");
            return false;
        });
    }
    /**
     *
     * @param key
     * @param value
     * @returns
     */
    updateToken(key, value) {
        return __awaiter(this, void 0, void 0, function* () {
            let profile = yield this.profile$.getValue();
            if (profile) {
                if (profile.tokens == null)
                    profile.tokens = new Map();
                profile.tokens.set(key, value);
                return this.profileDAO.updateTokens(profile).then(result => {
                    this.profile$.next(profile);
                    return true;
                }).catch(err => {
                    return false;
                });
            }
            else
                return false;
        });
    }
    updateUser(profile) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.profileDAO.updateProfile(profile).then(result => {
                if (result)
                    this.profile$.next(profile);
                return result;
            });
        });
    }
}
UserService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: UserService, deps: [{ token: AuthService }, { token: ProfileDaoService }, { token: i2$1.LoggerService }], target: i0.ɵɵFactoryTarget.Injectable });
UserService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: UserService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: UserService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: AuthService }, { type: ProfileDaoService }, { type: i2$1.LoggerService }]; } });

class AdminGuard {
    constructor(router, afAuth, profileService, displayer) {
        this.router = router;
        this.afAuth = afAuth;
        this.profileService = profileService;
        this.displayer = displayer;
    }
    canActivate(next, state) {
        return new Promise((resolve, reject) => {
            this.afAuth.onAuthStateChanged((user) => {
                if (user) {
                    this.profileService.getUser().subscribe(profile => {
                        if (profile) {
                            if (profile.isAdmin)
                                resolve(true);
                            else {
                                this.displayer.presentAlert("Erreur", "Droits insuffisants", "Désolé, vous ne possédez pas les droits pour accéder à cette partie.");
                                this.router.navigate(["connexion"], { queryParams: { url: next.url } });
                                resolve(false);
                            }
                        }
                    });
                }
                else {
                    this.displayer.presentAlert("Erreur", "Vous n'êtes pas connecté", "Désolé, connectez-vous pour accéder à cette partie.");
                    this.router.navigate(["connexion"], { queryParams: { url: next.url } });
                    resolve(false);
                }
            });
        });
    }
}
AdminGuard.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: AdminGuard, deps: [{ token: i1.Router }, { token: i2.AngularFireAuth }, { token: UserService }, { token: i2$1.DisplayerService }], target: i0.ɵɵFactoryTarget.Injectable });
AdminGuard.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: AdminGuard, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: AdminGuard, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.Router }, { type: i2.AngularFireAuth }, { type: UserService }, { type: i2$1.DisplayerService }]; } });

class UsersService {
    constructor(dao, logger) {
        this.dao = dao;
        this.logger = logger;
        this.users$ = new BehaviorSubject(null);
        this.usersId$ = new BehaviorSubject(null);
        this.dao.getProfiles$().subscribe(profiles => {
            console.log("profiles", profiles);
            let profilesId = new Map();
            for (let profile of profiles) {
                profilesId.set(profile.uid, profile);
            }
            console.log("profilesId", profilesId);
            this.users$.next(profiles);
            this.usersId$.next(profilesId);
        });
    }
    ;
    getUsers$() {
        return this.users$;
    }
    getUsersUid$() {
        return this.usersId$;
    }
    getUsersWithLimitAsync(limit = 8, start = null, orderBy = "") {
        return this.dao.getProfilesWithLimitAsync(limit, start, orderBy);
    }
}
UsersService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: UsersService, deps: [{ token: ProfileDaoService }, { token: i2$1.LoggerService }], target: i0.ɵɵFactoryTarget.Injectable });
UsersService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: UsersService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: UsersService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: ProfileDaoService }, { type: i2$1.LoggerService }]; } });

class FileService {
    constructor(afStorage, displayer, logger) {
        this.afStorage = afStorage;
        this.displayer = displayer;
        this.logger = logger;
        this.percentage = 0;
        this.uploadPercent = new BehaviorSubject(0);
        this.downloadURL = null;
    }
    /**
     * Fonction qui renvoi un observateur de l'avancement du téléchargement
     * @returns
     */
    getUploadPercent() {
        return this.uploadPercent;
    }
    /**
     * Téléchargement du fichier au chemin spécifié
     * @param path
     * @param data
     * @param fileType
     * @returns
     */
    uploadToPath(path, // The firebase path
    data, fileType) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                this.uploadPercent.next(0);
                yield this.displayer.presentLoader("Chargement du fichier<br/>0%");
                console.log("path", path, "data", data, "fileType", fileType);
                //const storageRef: firebase.storage.Reference = firebase.storage().ref(path+"-"+moment().format("DD-MM-YYYY-H-mm-ss-a")+"."+fileType.split('/')[1]);
                const storageRef = firebase.storage().ref(path + "." + fileType.split('/')[1]);
                let transfer;
                data = data.split(',')[1];
                console.log("image path " + path);
                console.log("image " + data);
                console.log("image type " + fileType);
                transfer = storageRef.putString(data, 'base64', { contentType: fileType });
                const self = this;
                transfer.on('state_changed', function progress(snapshot) {
                    return __awaiter(this, void 0, void 0, function* () {
                        self.percentage = (snapshot['bytesTransferred'] / snapshot['totalBytes']) * 100;
                        self.uploadPercent.next(self.percentage);
                        yield self.displayer.setMessageLoader("Chargement du fichier<br/>" + parseFloat((self.percentage / 1.2).toFixed(2)) + "%");
                        console.log("% " + self.percentage);
                        //task.setPercentage(this.percentage);
                    });
                }, function error(err) {
                    return __awaiter(this, void 0, void 0, function* () {
                        yield self.displayer.dismissLoader();
                        yield self.displayer.presentAlert("Erreur de chargement", err.message, "Une erreur s'est produite lors du chargement de votre dicument");
                        console.error(err);
                        reject(err);
                        //task.complete();
                    });
                }, function complete() {
                    return __awaiter(this, void 0, void 0, function* () {
                        yield self.displayer.dismissLoader();
                        storageRef.getDownloadURL().then(downloadURL => {
                            resolve(downloadURL);
                        });
                        console.log("Upload done");
                        //task.complete();
                    });
                });
            }));
        });
    }
    /**
     * Fonction qui supprime un fichier
     * @param path chemin du fichier à supprimer
     * @returns vrai ou faux suivant le résultat de l'opération
     */
    deleteFile(path) {
        return __awaiter(this, void 0, void 0, function* () {
            const storageRef = firebase.storage().refFromURL(path);
            return storageRef.delete().then((value) => {
                this.logger.object(FileService.name + " - deleteFile", "success");
                return true;
            }).catch((err) => {
                this.logger.object(FileService.name + " - deleteFile", err, "error");
                return false;
            });
        });
    }
    /**
     * Fonction qui redimmensionne une image
     * @param data
     * @param fileType
     * @param MAX_WIDTH
     * @param MAX_HEIGHT
     * @param quality
     * @returns
     */
    resizeImage(data, fileType, MAX_WIDTH = 400, MAX_HEIGHT = 400, quality = 1) {
        return new Promise((resolve) => __awaiter(this, void 0, void 0, function* () {
            var canvas = yield document.createElement("canvas");
            var image = new Image();
            image.crossOrigin = 'Anonymous';
            image.onload = () => __awaiter(this, void 0, void 0, function* () {
                var width = image.width;
                var height = image.height;
                if (width > height) {
                    if (width > MAX_WIDTH) {
                        height *= MAX_WIDTH / width;
                        width = MAX_WIDTH;
                    }
                }
                else {
                    if (height > MAX_HEIGHT) {
                        width *= MAX_HEIGHT / height;
                        height = MAX_HEIGHT;
                    }
                }
                canvas.width = width;
                canvas.height = height;
                var ctx = canvas.getContext("2d");
                yield ctx.drawImage(image, 0, 0, width, height);
                // IMPORTANT: 'jpeg' NOT 'jpg'
                var dataUrl = canvas.toDataURL(fileType, quality);
                console.log(dataUrl);
                console.log(this.getImageSize(dataUrl));
                image.remove();
                resolve(dataUrl);
            });
            image.src = data;
        }));
    }
    getImageSize(data_url) {
        var head = 'data:image/jpeg;base64,';
        return ((data_url.length - head.length) * 3 / 4 / (1024 * 1024)).toFixed(4);
    }
}
FileService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: FileService, deps: [{ token: i1$2.AngularFireStorage }, { token: i2$1.DisplayerService }, { token: i2$1.LoggerService }], target: i0.ɵɵFactoryTarget.Injectable });
FileService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: FileService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: FileService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1$2.AngularFireStorage }, { type: i2$1.DisplayerService }, { type: i2$1.LoggerService }]; } });

class ParserCSVService {
    constructor(platform, papa) {
        this.platform = platform;
        this.papa = papa;
    }
    exportCsv(headerRows, csvDatas, fileName = "data") {
        let csv = this.papa.unparse({
            fields: headerRows,
            data: csvDatas
        });
        if (this.platform.is('android') || this.platform.is('ios')) {
            Filesystem.writeFile({
                path: fileName + '.csv',
                data: csv,
                directory: Directory.Documents,
                encoding: Encoding.UTF8,
            }).then(res => {
                console.log("ok", res);
            }, err => {
                console.log("Error", err);
            });
        }
        else {
            // Dummy implementation for Desktop download purpose
            var blob = new Blob([csv]);
            var a = window.document.createElement('a');
            a.href = window.URL.createObjectURL(blob);
            a.download = fileName + '.csv';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        }
    }
}
ParserCSVService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: ParserCSVService, deps: [{ token: i1$3.Platform }, { token: i2$2.Papa }], target: i0.ɵɵFactoryTarget.Injectable });
ParserCSVService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: ParserCSVService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: ParserCSVService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1$3.Platform }, { type: i2$2.Papa }]; } });

class CountryDaoService {
    constructor(afStore, logger) {
        this.afStore = afStore;
        this.logger = logger;
        this.countriesObs = new BehaviorSubject(null);
        this.countriesByCodeObs = new BehaviorSubject(null);
        this.countriesByIdObs = new BehaviorSubject(null);
        this.afStore.collection("/countries").valueChanges().
            pipe(map(countries => { return countries; })).subscribe(countries => {
            if (countries) {
                this.countriesObs.next(countries);
                let countriesById = new Map();
                let countriesByCode = new Map();
                for (let country of countries) {
                    countriesById.set(country.id, country);
                    countriesByCode.set(country.code, country);
                }
                this.countriesByIdObs.next(countriesById);
                this.countriesByCodeObs.next(countriesByCode);
            }
        });
    }
    createId() {
        return this.afStore.createId();
    }
    getCountries() {
        return this.countriesObs;
    }
    getCountriesById() {
        return this.countriesByIdObs;
    }
    getCountriesByCode() {
        return this.countriesByCodeObs;
    }
    setCountry(pCountry, pDatas) {
        return __awaiter(this, void 0, void 0, function* () {
            if (pCountry.id == "") {
                let id = this.createId();
                pCountry.id = id;
                pDatas.id = id;
                return yield this.createCountry(pCountry, pDatas);
            }
            else {
                return yield this.updateCountry(pCountry, pDatas);
            }
        });
    }
    updateCountry(pCountry, pDatas) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.afStore.collection("countries").doc(pCountry.id).set(pDatas).then(() => {
                return pCountry;
            }).catch(err => {
                this.logger.message(CountryDaoService.name, err, "error");
                return null;
            });
        });
    }
    createCountry(pCountry, pDatas) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.afStore.collection("countries").doc(pCountry.id).update(pDatas).then(() => {
                return pCountry;
            }).catch(err => {
                this.logger.message(CountryDaoService.name, err, "error");
                return null;
            });
        });
    }
}
CountryDaoService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: CountryDaoService, deps: [{ token: i1$1.AngularFirestore }, { token: i2$1.LoggerService }], target: i0.ɵɵFactoryTarget.Injectable });
CountryDaoService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: CountryDaoService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: CountryDaoService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1$1.AngularFirestore }, { type: i2$1.LoggerService }]; } });

class CountryService {
    constructor(dao) {
        this.dao = dao;
    }
    getCountries() {
        return this.dao.getCountries();
    }
    getCountriesByCode() {
        return this.dao.getCountriesByCode();
    }
    getCountriesById() {
        return this.dao.getCountriesById();
    }
    setCountry(pCountry, pDatas) {
        return this.dao.setCountry(pCountry, pDatas);
    }
}
CountryService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: CountryService, deps: [{ token: CountryDaoService }], target: i0.ɵɵFactoryTarget.Injectable });
CountryService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: CountryService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: CountryService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: CountryDaoService }]; } });

/*
 * Public API Surface of octali-lib-firebase-utils
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AdminGuard, AuthGuard, AuthService, CountryService, FileService, OctaliLibFirebaseUtilsComponent, OctaliLibFirebaseUtilsModule, OctaliLibFirebaseUtilsService, ParserCSVService, UserService, UsersService };
